(function(){
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
  function num(v){if(v===null||v===undefined)return null;var s=String(v).trim();if(!s)return null;var n=parseFloat(s.replace(',','.'));return isFinite(n)?n:null;}
  function parseCSV(t){
    var rows=[],row=[],f='',q=false,i=0,c;
    t=t.replace(/^\uFEFF/,'');
    for(;i<t.length;i++){c=t[i];
      if(q){if(c==='"'){if(t[i+1]==='"'){f+='"';i++;}else q=false;}else f+=c;}
      else if(c==='"')q=true;
      else if(c===','){row.push(f);f='';}
      else if(c==='\n'||c==='\r'){if(c==='\r'&&t[i+1]==='\n')i++;row.push(f);rows.push(row);row=[];f='';}
      else f+=c;}
    if(f!==''||row.length){row.push(f);rows.push(row);}
    return rows;
  }
  /* Only these public columns are ever read from a feed. Anything else in the file is ignored. */
  var COLS={'name':'name','category':'category','min players':'minPlayers','max players':'maxPlayers','best with':'bestWith','min time':'minTime','max time':'maxTime','complexity':'complexity','complexity label':'complexityLabel','min age':'minAge','year':'year'};
  function fromCSV(text){
    var rows=parseCSV(text);if(rows.length<2)return [];
    var head=rows[0].map(function(h){return h.trim().toLowerCase().replace(/\s*\(.*\)$/,'');});
    var out=[];
    for(var r=1;r<rows.length;r++){var g={};
      head.forEach(function(h,i){if(COLS[h])g[COLS[h]]=(rows[r][i]||'').trim();});
      if(!g.name)continue;out.push(tidy(g));}
    return out;
  }
  function tidy(g){
    var o={name:String(g.name||'').trim(),category:String(g.category||'').trim(),bestWith:g.bestWith?String(g.bestWith).trim():''};
    ['minPlayers','maxPlayers','minTime','maxTime','complexity','minAge','year'].forEach(function(k){o[k]=num(g[k]);});
    var l=String(g.complexityLabel||'').trim();
    if(!/^(Light|Medium|Heavy)$/i.test(l)){l=o.complexity==null?'':(o.complexity<2?'Light':o.complexity<3?'Medium':'Heavy');}
    o.complexityLabel=l?l.charAt(0).toUpperCase()+l.slice(1).toLowerCase():'';
    if(o.minPlayers!=null&&o.maxPlayers!=null&&o.maxPlayers<o.minPlayers)o.maxPlayers=null;
    if(o.minTime==null&&o.maxTime!=null)o.minTime=o.maxTime;
    if(o.maxTime==null&&o.minTime!=null)o.maxTime=o.minTime;
    o.key=o.name.toLowerCase();
    return o;
  }
  function dedupe(list){var seen={},out=[];list.forEach(function(g){if(g.name&&!seen[g.key]){seen[g.key]=1;out.push(g);}});return out;}
  function fetchText(url,ms){
    var ctl=window.AbortController?new AbortController():null;var t=setTimeout(function(){if(ctl)ctl.abort();},ms);
    return fetch(url,{signal:ctl?ctl.signal:undefined,credentials:'omit'}).then(function(r){clearTimeout(t);if(!r.ok)throw new Error(r.status);return r.text();});
  }
  function load(root){
    var feed=(root.getAttribute('data-feed')||'').trim(),json=root.getAttribute('data-json');
    function bundled(){return fetchText(json,10000).then(function(t){var d=JSON.parse(t);return {games:(d.games||[]).map(tidy),from:'bundled'};});}
    if(!feed)return bundled();
    return fetchText(feed,8000).then(function(t){
      var g=/^\s*[\[{]/.test(t)?(JSON.parse(t).games||JSON.parse(t)).map(tidy):fromCSV(t);
      if(g.length<10)throw new Error('feed too small');return {games:g,from:'feed'};
    }).catch(function(e){if(window.console)console.warn('Games feed unavailable, using bundled list',e);return bundled();});
  }
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function fmtRange(a,b){if(a==null)return '';if(b==null||b===a)return String(a);return a+' to '+b;}
  function init(root){
    var T=JSON.parse(root.querySelector('.glib-text').textContent);
    var $=function(s){return root.querySelector(s);};
    var q=$('.glib-q'),pl=$('.glib-players'),tm=$('.glib-time'),cat=$('.glib-cat'),age=$('.glib-age'),sort=$('.glib-sort'),
        cx=root.querySelectorAll('.glib-cx input'),list=$('.glib-list'),count=$('.glib-count'),more=$('.glib-more'),clear=$('.glib-clear'),empty=$('.glib-empty');
    var all=[],shown=0,cur=[],page=parseInt(root.getAttribute('data-page'),10)||48;
    var BANDS={quick:[0,30],mid:[31,60],long:[61,120],epic:[121,100000]};
    function matches(g){
      var s=q.value.trim().toLowerCase();
      if(s&&g.key.indexOf(s)<0&&g.key.replace(/[^a-z0-9 ]/g,'').indexOf(s.replace(/[^a-z0-9 ]/g,''))<0)return false;
      var n=parseInt(pl.value,10);
      if(n){if(g.minPlayers==null)return false;var mx=g.maxPlayers==null?g.minPlayers:g.maxPlayers;if(pl.value==='10+'){if(mx<10)return false;}else if(n<g.minPlayers||n>mx)return false;}
      var b=BANDS[tm.value];
      if(b){if(g.maxTime==null)return false;if(g.maxTime<b[0]||g.maxTime>b[1])return false;}
      if(cat.value&&g.category!==cat.value)return false;
      var a=parseInt(age.value,10);
      if(a){if(g.minAge==null||g.minAge>a)return false;}
      var on=[];cx.forEach(function(c){if(c.checked)on.push(c.value);});
      if(on.length&&on.indexOf(g.complexityLabel)<0)return false;
      return true;
    }
    function cmp(k,dir){return function(a,b){var x=a[k],y=b[k];if(x==null&&y==null)return a.key<b.key?-1:1;if(x==null)return 1;if(y==null)return -1;if(x===y)return a.key<b.key?-1:1;return (x<y?-1:1)*dir;};}
    var SORTS={az:function(a,b){return a.key<b.key?-1:a.key>b.key?1:0;},za:function(a,b){return a.key>b.key?-1:a.key<b.key?1:0;},
      quick:cmp('minTime',1),long:cmp('maxTime',-1),light:cmp('complexity',1),heavy:cmp('complexity',-1),most:cmp('maxPlayers',-1),new:cmp('year',-1)};
    function card(g){
      var f=[];
      if(g.minPlayers!=null){var p=(g.maxPlayers==null&&g.minPlayers>1)||(g.maxPlayers!=null&&g.maxPlayers>=20)?g.minPlayers+' '+T.or_more:fmtRange(g.minPlayers,g.maxPlayers);
        f.push('<li><span class="k">'+esc(T.players)+'</span> '+esc(p)+'</li>');}
      if(g.minTime!=null)f.push('<li><span class="k">'+esc(T.time)+'</span> '+esc(fmtRange(g.minTime,g.maxTime))+' '+esc(T.minutes)+'</li>');
      if(g.complexityLabel)f.push('<li><span class="k">'+esc(T.complexity)+'</span> <span class="cxp cx-'+g.complexityLabel.toLowerCase()+'">'+esc(T['cx_'+g.complexityLabel.toLowerCase()]||g.complexityLabel)+'</span></li>');
      if(g.minAge!=null)f.push('<li><span class="k">'+esc(T.age)+'</span> '+esc(g.minAge)+'+</li>');
      if(g.bestWith)f.push('<li class="glib-best"><span class="k">'+esc(T.best)+'</span> '+esc(g.bestWith)+' '+esc(String(g.bestWith)==='1'?T.player_one:T.players_word)+'</li>');
      if(!f.length)f.push('<li class="ask">'+esc(T.ask)+'</li>');
      return '<li class="glib-card"><h3>'+esc(g.name)+'</h3>'+(g.category?'<p class="gcat">'+esc(g.category)+'</p>':'')+'<ul class="gfacts">'+f.join('')+'</ul></li>';
    }
    function render(reset){
      if(reset){cur=all.filter(matches).sort(SORTS[sort.value]||SORTS.az);shown=0;list.innerHTML='';}
      var next=cur.slice(shown,shown+page);list.insertAdjacentHTML('beforeend',next.map(card).join(''));shown+=next.length;
      count.textContent=T.count.replace('[shown]',cur.length).replace('[total]',all.length);
      empty.hidden=cur.length>0;more.hidden=shown>=cur.length;
      var active=q.value.trim()||pl.value||tm.value||cat.value||age.value||Array.prototype.some.call(cx,function(c){return c.checked;});
      clear.disabled=!active;
    }
    var timer;q.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(function(){render(true);},150);});
    [pl,tm,cat,age,sort].forEach(function(e){e.addEventListener('change',function(){render(true);});});
    cx.forEach(function(c){c.addEventListener('change',function(){render(true);});});
    more.addEventListener('click',function(){var first=shown;render(false);var el=list.children[first];if(el){el.setAttribute('tabindex','-1');el.focus();}});
    clear.addEventListener('click',function(){q.value='';pl.value='';tm.value='';cat.value='';age.value='';cx.forEach(function(c){c.checked=false;});render(true);q.focus();});
    root.querySelector('form').addEventListener('submit',function(e){e.preventDefault();render(true);});
    load(root).then(function(d){
      all=dedupe(d.games);root.setAttribute('data-source',d.from);
      var cats={};all.forEach(function(g){if(g.category)cats[g.category]=1;});
      Object.keys(cats).sort().forEach(function(c){var o=document.createElement('option');o.value=c;o.textContent=c;cat.appendChild(o);});
      root.classList.add('is-ready');render(true);
    }).catch(function(){count.textContent=T.error;});
  }
  ready(function(){document.querySelectorAll('[data-cod-games]').forEach(init);});
})();
